(function () {
  function initInfiniteSlider(sliderComponent) {
    if (!sliderComponent || sliderComponent.dataset.zpInfiniteInit === "1") return;

    const slider = sliderComponent.querySelector("ul.slider");
    if (!slider) return;

    const originalSlides = Array.from(slider.querySelectorAll("li.slider__slide"));
    if (originalSlides.length < 2) return;

    const visibleDesktop = parseInt(sliderComponent.dataset.zpVisibleDesktop || "4", 10);
    const visibleMobile = parseInt(sliderComponent.dataset.zpVisibleMobile || "2", 10);

    const isMobileNow = () => window.matchMedia("(max-width: 749px)").matches;

    // cloni (una sola volta)
    if (slider.dataset.zpCloned !== "1") {
      const clonesCount = Math.max(1, isMobileNow() ? visibleMobile : visibleDesktop);

      const headClones = originalSlides.slice(0, clonesCount).map((el) => el.cloneNode(true));
      const tailClones = originalSlides.slice(-clonesCount).map((el) => el.cloneNode(true));

      headClones.forEach((c) => c.setAttribute("data-zp-clone", "1"));
      tailClones.forEach((c) => c.setAttribute("data-zp-clone", "1"));

      // prepend ultimi N
      tailClones.reverse().forEach((c) => slider.insertBefore(c, slider.firstChild));
      // append primi N
      headClones.forEach((c) => slider.appendChild(c));

      slider.dataset.zpCloned = "1";
      slider.dataset.zpClonesCount = String(clonesCount);
    }

    const clonesCount = parseInt(slider.dataset.zpClonesCount || "1", 10);
    const realCount = originalSlides.length;
    const allSlides = () => Array.from(slider.querySelectorAll("li.slider__slide"));

    // CSS helper per jump senza smooth
    if (!document.getElementById("zp-infinite-style")) {
      const style = document.createElement("style");
      style.id = "zp-infinite-style";
      style.textContent = `
        .zp-no-smooth { scroll-behavior: auto !important; }
      `;
      document.head.appendChild(style);
    }

    function getStep() {
      const slides = allSlides();
      const a = slides[0];
      const b = slides[1];
      if (!a || !b) return a ? a.getBoundingClientRect().width : 0;
      const r1 = a.getBoundingClientRect();
      const r2 = b.getBoundingClientRect();
      return Math.round(r2.left - r1.left);
    }

    function jumpToRealStart() {
      const step = getStep();
      slider.classList.add("zp-no-smooth");
      slider.scrollLeft = step * clonesCount;
      slider.offsetHeight; // reflow
      slider.classList.remove("zp-no-smooth");
    }

    function handleLoop() {
      const step = getStep();
      const min = step * clonesCount;
      const max = step * (clonesCount + realCount);

      // troppo a sinistra -> salta a fine reale
      if (slider.scrollLeft <= min - step * 0.5) {
        slider.classList.add("zp-no-smooth");
        slider.scrollLeft = max - step;
        slider.offsetHeight;
        slider.classList.remove("zp-no-smooth");
      }

      // troppo a destra -> salta a inizio reale
      if (slider.scrollLeft >= max + step * 0.5) {
        slider.classList.add("zp-no-smooth");
        slider.scrollLeft = min + step;
        slider.offsetHeight;
        slider.classList.remove("zp-no-smooth");
      }
    }

    // 1) posizionati sul primo reale
    jumpToRealStart();

    // 2) loop su scroll
    let raf = null;
    slider.addEventListener("scroll", () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(handleLoop);
    });

    // 3) frecce: intercetta e fai scroll di 1 step (bloccando Dawn)
    const prevBtn = sliderComponent.querySelector(".slider-button--prev");
    const nextBtn = sliderComponent.querySelector(".slider-button--next");

    function go(dir) {
      const step = getStep();
      slider.scrollBy({ left: dir * step, behavior: "smooth" });

      // assicurati che il loop corregga eventuali cloni dopo l'animazione
      setTimeout(handleLoop, 350);
      setTimeout(handleLoop, 700);
    }

    function bind(btn, dir) {
      if (!btn || btn.dataset.zpBound === "1") return;
      btn.dataset.zpBound = "1";

      // CAPTURE + stopImmediatePropagation = blocca listener di Dawn
      btn.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          go(dir);
        },
        true
      );
    }

    bind(prevBtn, -1);
    bind(nextBtn, +1);

    // 4) resize: riparti bene in mezzo ai cloni
    window.addEventListener("resize", () => {
      jumpToRealStart();
    });

    sliderComponent.dataset.zpInfiniteInit = "1";
  }

  function boot() {
    document
      .querySelectorAll('slider-component[data-zp-loop="true"]')
      .forEach(initInfiniteSlider);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
